<template>
  <i-dropdown>
    <template v-slot:trigger="{toggle, attrs}">
      <button
        class="i-button btn i-simple-btn"
        @click="toggle"
        v-bind="attrs">
          <i class="fas fa-columns fa5" aria-hidden="true"></i>
          <span >{{ LANG.columns }}</span>
          <i class="fas fa-caret-down pl1" aria-hidden="true"></i>
      </button>
    </template>
    <ul class="dropdown-menu i-dropdown-menu block pull-right overflow-y-auto">
      <li v-for="{id, checked, label} in list"
        role="option"
        :aria-label="label"
        :key="id">
        <a href="#"
          @click.stop.prevent="() => toggleColumn({ name: id })"
          @keydown.enter.stop.prevent="() => toggleColumn({ name: id })"
          :title="label">
          <i class="fa5"
            :class="checked ? 'fas fa-check-square': 'far fa-square gray'"
            name="check-square"></i>
          <span>{{ label }}</span>
        </a>
      </li>
    </ul>
  </i-dropdown>
</template>

<script>
import { mapState } from 'vuex';
import { mapBrowserMutations, mapBrowserGetters } from '@/store';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(['LANG']),
    ...mapBrowserGetters([
      'sortedColumns',
    ]),
    list() {
      return this.sortedColumns
        .filter((c) => !c.isAlwaysOn)
        .map((c) => ({
          id: c.name,
          label: c.label,
          checked: c.active,
        }));
    },
  },
  methods: {
    ...mapBrowserMutations([
      'toggleColumn',
    ]),
  },
};
</script>

<style scoped lang='scss'>
.i-dropdown-menu {
  max-height: 415px;
  width: 200px;
}
.fa5.gray {
  color: #acacac;
}
</style>
